import React , {useState, useEffect, useCallback} from 'react'
import { Link } from "react-router-dom";
import Header from '../components/Header'
import Footer from '../components/Footer'
import Monoperc from '../components/Monoperc'
import Manufacture from '../components/Manufacture'
import Popup from '../components/popup/ProductPopup'
import usePageSEO from '../hooks/usePageSEO'
import axios from "axios";
import Loader from '../components/Loader'
import Slider from 'react-slick';

{/*------Child component */ }

function ChildComponent(props) {
  const arrayData = props.data;

     return (
    <>
      <h3>Child Component</h3>
      <ul>
        {arrayData.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </>
  );
}

const Products = () =>{
  const myArray = [10, 20, 30, 40, 50];
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;     
  const [open, setOpen] = useState(false);
  const [enquiry, setEnquiry] = useState('');

  const [data, setData] = useState('');
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')

  const [product1, setProduct1] = useState(null);
  const [product2, setProduct2] = useState(null);
  const [product3, setProduct3] = useState(null);

  const [monoperc, setMonoperc] = useState(null);
  const [topcon, setTopcon] = useState(null);
  const [feature, setFeature] = useState(null);
  const [facility, setFacility] = useState(null);        
  const [modCert, setModCert] = useState(null);
  const [strucCat, setStrucCat] = useState(null);
  
  
  const apiUrl = apiBaseUrl+`productpage`;

  const callEnquiry = (txt) =>{
    setEnquiry(txt);
    setOpen(true);
  }

  const fetchInfo = useCallback(() => {
    return axios.get(apiUrl).then((res) => {
      setData(res.data.page);
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setProduct1(res.data.product1)
      setProduct2(res.data.product2)
      setProduct3(res.data.product3)
      setMonoperc(res.data.monoperc_module)
      setTopcon(res.data.topcon_module)
      setFeature(res.data.features)
      setFacility(res.data.manufacture_facility)
      setModCert(res.data.module_certificate)
      setStrucCat(res.data.structure_category)
    });
  },[]);


  useEffect(() => {
    setTimeout(() => {
      fetchInfo()
        setLoading(false);
    }, 2000);
  }, [fetchInfo]);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })  

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    navigator: false,
    prevArrow: false,
    nextArrow: false,
    responsive: [
        {
            breakpoint: 600,
            settings: {
            slidesToShow: 1,
            },
        },
        ],          
}; 


  return (
    <>
    <Header/>

    { loading && (<Loader /> )}	
    
    <section className="section-content-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                        <div className="about-us-intro">
                            <p className="blue">{data?.name}</p>
                            <h2 className="heading col-lg-offset-3 col-lg-6 col-md-12 col-sm-12 col-xs-12">{data?.page_heading}</h2>
                            <p className='col-lg-offset-2 col-lg-8 col-sm-12'>{data?.short_description}</p>
                        </div>                            
                    </div> 
                </div>
				
				<div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                        <div className="Products">
                            {data?.image && (
                                <img src={`${siteUrl}${data?.image}`} alt={data?.name} /> 
                            )}
                        </div>                            
                    </div> 
                </div>
            </div> 
    </section>
		
    <div className="container vertiocal-gap-100" id="solar-module"><hr/></div>
    
    <section className="section-content-block">

        <div className="container">
            
            <div className="row">

                <div className="col-lg-6 col-md-6 col-sm-12">                       
                    <div className="about-us-intro">
                        <p className="blue">{product1?.name}</p>
                        <h2 className="heading col-lg-9 col-sm-12 pl-0">{product1?.heading}</h2>
                        <p className='col-sm-12 pl-0'>{product1?.description}</p>
                        <p className='col-sm-12 pl-0'><button 
                            className="btn btn-button margin-top-60" 
                            onClick={() => callEnquiry('Solar Module')}>Enquire now
                        </button>
                        </p>
                    </div>                            
                </div> 
                <div className="col-lg-6 col-md-6 col-sm-12 Products text-right">
                    <img src={`${siteUrl}${product1?.image}`} alt={product1?.name}/>               
                </div>

            </div>
            

        </div> 

    </section>

        
        
	<div className="container"><hr/></div>
		
    <section className="section-content-block">

        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                    <div className="about-us-intro">
                        <p className="blue">{monoperc?.name}</p>
                        <h2 className="heading col-lg-offset-3 col-lg-6 col-sm-12">{monoperc?.heading}</h2>
                    </div>                            
                </div> 
            </div>

            {(monoperc?.feature_item.length) > 0 && (            
            <div className="row pb-100">
                <div className="modules-carousel col-sm-12">
                    <Slider {...settings}>
                        {monoperc?.feature_item.map((item, index)=>{
                            return(
                                <Monoperc
                                    key={index}
                                    param={{
                                        name: item?.name,
                                        description: item?.description,
                                        datasheet_link: `${siteUrl}${item?.datasheet_link}`,
                                        image: `${siteUrl}${item?.image}`
                                    }}
                                />
                            )
                        })}
                    </Slider>
                </div>
            </div>
            )}
        </div> 
    </section>
		
	<div className="container"><hr/></div>


    <section className="section-content-block TopCon">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                    <div className="about-us-intro">
                        <p className="blue">{topcon?.name}</p>
                        <h2 className="heading col-lg-offset-3 col-lg-6 col-sm-12">{topcon?.heading}</h2>
                        <p className='col-sm-12'><span className="launching" style={{ cursor: 'default'}}>Launching soon</span></p>
                    </div>                            
                </div> 
                
            </div>

            {(topcon?.feature_item.length) > 0 && (            
            <div className="row pb-100">
                <div className="modules-carousel col-sm-12">
                    <Slider {...settings}>
                        {topcon?.feature_item.map((item, index)=>{
                            return(
                                <Monoperc
                                    key={index}
                                    param={{
                                        name: item?.name,
                                        description: item?.description,
                                        datasheet_link: item?.datasheet_link,
                                        image: `${siteUrl}${item?.image}`                                      
                                    }}
                                />
                            )
                        })}
                    </Slider>
                </div>
            </div>
            )}
        </div> 
    </section>

	<div className="container"><hr/></div>


    <section className="section-content-block">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                    <div className="about-us-intro">
                        <p className="blue">{feature?.name}</p>
                        <h2 className="heading col-lg-offset-3 col-lg-6 col-sm-12">{feature?.heading}</h2>
                        <p className='col-lg-offset-2 col-lg-8 col-sm-12'>{feature?.description}</p>
                    </div>                            
                </div> 
            </div>
            {(feature?.feature_item.length) > 0 && (
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">                       
                    <div className="Products features-module">
                        <ul>
                            {feature?.feature_item.map((item, index)=>{
                                return(
                                    <li key={index}>{item?.name}</li>
                                )
                            })}
                            
                        </ul>
                    </div>                            
                </div> 

            </div>
            )}            
        </div> 
    </section>

    
    <section className="section-content-block bg-gray">

        <div className="container">
            <div className="row">
            <div className="col-sm-12">                       
                    <div className="about-us-intro text-center">
                        <p className="our-experience">{facility?.heading}</p>
                        <p className='col-lg-offset-3 col-lg-6 col-sm-12'>{facility?.description}</p>
                    </div>                            
                </div>
            </div>
            {(facility?.feature_item.length) > 0 && (
            <div className="row pb-100">
                <div className="manufacturing-carousel col-sm-12 owl-carousel1">
                    <Slider {...settings}>
                    {facility?.feature_item.map((item, index)=>{
                        return(
                            <Manufacture 
                                key={index}
                                prm={{ 
                                name: item?.name,
                                image: `${siteUrl}${item?.image}`,
                                }}                    
                            />
                        )
                    })}
                    </Slider>

                </div>
            
            </div>
            )}            
            

            
            
            
        </div> 

    </section>
		
		
    <section className="section-content-block">
        <div className="container wow fadeIn animated animated" style={{ visibility: "visible", animationName: "fadeIn" }}>
            <div className="row">
                <div className="col-sm-12 text-center"> 
                    <p className="blue">{modCert?.name}</p>
                    <p className="our-experience">{modCert?.heading}</p>
                    <p className="about-us-intro">{modCert?.description}</p>
                </div>	
            </div>
            {(modCert?.feature_item.length > 0) && (
                <div className="row text-center margin-top-32 solar-advantage client-logo">
                    <ul>
                        {modCert?.feature_item.map((item, index)=>{
                            return(
                                <li className="" key={index}> 
                                    <div className="meeting">
                                        <img src={`${siteUrl}${item?.image}`} alt={item?.name}/>
                                    </div>
                                </li>
                            )
                        })}                       
                    </ul>
                </div>
            )}
        </div>       
    </section>
		
	<div className="container" id="solar-cell"><hr/></div>

    <section className="section-content-block">

        <div className="container">
            
            <div className="row">

                <div className="col-lg-6 col-md-6 col-sm-12">                       
                    <div className="about-us-intro">
                        <p className="blue">{product2?.name}</p>
                        <h2 className="heading">{product2?.heading}</h2>
                        <p>{product2?.description}</p>
                        <button 
                            className="btn btn-button margin-top-60" 
                            onClick={() => callEnquiry('Solar Cell')}>Enquire now
                        </button>                        
                    </div>                            
                </div> 
                <div className="col-lg-6 col-md-6 col-sm-12 Products text-right">
                    <img src={`${siteUrl}${product2?.image}`} alt={product2?.name}/>               
                </div>

            </div>
            

        </div> 

    </section>
		
	<div className="container" id="mounting-structure"><hr/></div>
	
	
    <section className="section-content-block">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">                       
                    <div className="about-us-intro">
                        <p className="blue">{product3?.name}</p>
                        <h2 className="heading">{product3?.heading}</h2>
                        <p>{product3?.description}</p>
                        <button 
                            className="btn btn-button margin-top-60" 
                            onClick={() => callEnquiry('Mounting Structure')}>Enquire now
                        </button>                        
                    </div>                            
                </div> 
                <div className="col-lg-6 col-md-6 col-sm-12 Products text-right">
                    <img src={`${siteUrl}${product3?.image}`} alt={product3?.name}/>               
                </div>

            </div>
            

        </div> 

    </section>

	<div className="container"><hr/></div>
        
    <section className="section-content-block">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                    <div className="about-us-intro">
                        <p className="blue">{strucCat?.name}</p>
                        <h2 className="heading">{strucCat?.heading}</h2>
                    </div>                            
                </div> 
                
            </div>
            
            <div className="row">
                {(strucCat?.feature_item.length > 0) && (
                   strucCat.feature_item.map((item,index)=>{
                    return(
                    <div className="col-lg-6 col-md-6 col-sm-12 text-center" key={index}>                       
                        <div className="Products">
                            <img src={`${siteUrl}${item?.image}`} alt={item?.name}/> 
                            <h5 className="heading1"><strong>{item?.name}</strong></h5>
                        </div>                            
                    </div>
                    )
                   })
                )}
            </div>
        </div> 
    </section>

    {open ? <Popup prm={enquiry} closePopup={() => setOpen(false)} /> : null}

    <Footer/>    


    
    </>
  )
}

export default Products